export default function customer({ services }: CommandArgs) {
  const eventTracker: EventTracker = services['event-tracker']

  function commitCustomerInfoOnQuote() {
    const quoteInput = services['quote-builder']
      .include('customer', ['withSmsOptin', 'withMarketingOptin'])
      .compose('customer')
      .tryCommit()

    eventTracker.track('add_contact_info')

    return quoteInput
  }

  return {
    commitCustomerInfoOnQuote
  }
}

declare global {
  export type CustomerCommands = ReturnType<typeof customer>

  // Add to global scope
  interface CommandRegistry {
    customer: CustomerCommands
  }
}
